import type { HTMLAttributes } from 'react';
import { cn } from '@worldcoo/ui/lib/utils';

/** Figma breakpoints: desktop 1440, mobile 375. */
export function Layout(props: HTMLAttributes<HTMLElement>) {
	return <main {...props} className={cn('font-brand text-ink min-h-screen', props.className)} />;
}
